// BuildSingleImageAsset.js

// Export a function that builds a preview-like asset from a single image
export const BuildSingleImageAsset = ({

    // This is the natural width of the user image in pixels
    naturalWidth,

    // This is the natural height of the user image in pixels
    naturalHeight,

    // This is the user image url (optional, for background/trim)
    imageUrl,

}) => {

    // If we don't have natural sizes yet, return null so the caller can wait
    if (!naturalWidth || !naturalHeight) {

        // Return null
        return null;

    }

    // Build a canvas the same size as the image
    const canvasWidth = Number(naturalWidth);

    // Build a canvas the same size as the image
    const canvasHeight = Number(naturalHeight);

    // Return a preview-shaped asset object
    return {

        // Match your existing "preview" type
        type: "preview",

        // Canvas width equals image width
        canvas_width: canvasWidth,

        // Canvas height equals image height
        canvas_height: canvasHeight,

        // Layers (optional)
        layers: [

            // Background layer can just be the image itself (or omit if you want)
            {
                type: "background",
                width: canvasWidth,
                height: canvasHeight,
                centre_x: canvasWidth / 2,
                centre_y: canvasHeight / 2,
                image_url: "",
                thumbnail_url: "",
            },

            // Trim layer can also be the image (or omit completely)
            {
                type: "trim",
                width: canvasWidth,
                height: canvasHeight,
                centre_x: canvasWidth / 2,
                centre_y: canvasHeight / 2,
                image_url: "",
                thumbnail_url: "",
                print_scale: 1,
            
            },

        ],

        // Positions: one full-canvas position called "trim"
        positions: [

            {
                code: "trim",
                name: "Full Area",
                top_left_x: 0,
                top_left_y: 0,
                bottom_right_x: canvasWidth,
                bottom_right_y: canvasHeight,
                width: canvasWidth,
                height: canvasHeight,
                centre_x: canvasWidth / 2,
                centre_y: canvasHeight / 2,
                preferred_fit: "Y",
                preferred_fill: "Y",
                description: null,
            },

        ],

    };

};
